import { ObserveVisibility } from 'vue-observe-visibility';
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('observe-visibility', ObserveVisibility);
});
